import { render, staticRenderFns } from "./feedbackList.vue?vue&type=template&id=fcf65cdc&scoped=true&"
import script from "./feedbackList.vue?vue&type=script&lang=ts&"
export * from "./feedbackList.vue?vue&type=script&lang=ts&"
import style0 from "./feedbackList.vue?vue&type=style&index=0&id=fcf65cdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf65cdc",
  null
  
)

export default component.exports